import { render, staticRenderFns } from "./product-type.vue?vue&type=template&id=b28374d4&scoped=true&lang=html&"
import script from "./product-type.vue?vue&type=script&lang=js&"
export * from "./product-type.vue?vue&type=script&lang=js&"
import style0 from "./product-type.vue?vue&type=style&index=0&lang=scss&module=productType&"
import style1 from "./product-type.vue?vue&type=style&index=1&id=b28374d4&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["productType"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b28374d4",
  null
  
)

export default component.exports